import React from 'react'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'

export default function PrintableTherapyRecommended({
  therapyRecommendedRef,
  debug,
  suggestedBookingTherapy,
  selectedTherapies, // Now also receives suggested therapies
  debugHighlightStates,
  styleOverrides,
}) {
  const hasTherapies = Array.isArray(selectedTherapies) && selectedTherapies.length > 0
  const therapyNames = hasTherapies 
    ? selectedTherapies.map((item) => item?.label).filter(Boolean).join(', ')
    : null

  return (
    <div
      ref={therapyRecommendedRef}
      style={{
        // No border, no rectangle - just plain text
        padding: 0,
        margin: 0,
        background: debug ? PRESCRIPTION_COLORS_MAP.selectedTherapy.color : 'transparent',
      }}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        PSYCHOTHERAPY RECOMMENDED: {suggestedBookingTherapy ? 'YES' : 'NO'}
      </span>
      {/* Show suggested therapies inline if available */}
      {hasTherapies && (
        <span
          style={{
            fontSize: styleOverrides?.fontSizePixels
              ? `${styleOverrides?.fontSizePixels}px`
              : 'inherit',
            color: styleOverrides?.color || 'inherit',
            marginLeft: '8px',
          }}
        >
          ({therapyNames})
        </span>
      )}
    </div>
  )
}
